import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogModelUploadCreditBillError } from "./model"

@Component({
  selector: 'app-upload-credit-bill-error',
  templateUrl: './upload-credit-bill-error.component.html',
  styleUrls: ['./upload-credit-bill-error.component.scss']
})
export class UploadCreditBillErrorComponent implements OnInit {
  view = "table";
  wrongItems = [];
  productName = "";
  wrongItemName = "";
  
  constructor(
    public dialogRef: MatDialogRef<UploadCreditBillErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogModelUploadCreditBillError
  ) {}

  ngOnInit(): void {
    console.log(this.data)
  }

  closeIt() {
    this.dialogRef.close(null);
  }

}
